import { render, staticRenderFns } from "./SH061ShopperItemInfoNoshi.vue?vue&type=template&id=ece9a96a&"
import script from "./SH061ShopperItemInfoNoshi.vue?vue&type=script&lang=js&"
export * from "./SH061ShopperItemInfoNoshi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports